import React, { useEffect, useState } from 'react';
import '../../resources/css/jump-button.css';

export default function JumpButton() {

    const [topClassName, setTopClassName] = useState('jump-button');

    const handleScroll = () => {

        if (window.scrollY > 200) {
            setTopClassName('jump-button v');
        }
        else {
            setTopClassName('jump-button');
        }
    };

    const handleClick = function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className={topClassName} onClick={handleClick}>
            <div>
                <i className="fa fa-arrow-up"></i>
            </div>
        </div>);
}